import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { deleteContentLibraryFolderRequested } from 'features/content-library/actions';

export function* deleteContentLibraryFolderSaga(
  action: ReturnType<typeof deleteContentLibraryFolderRequested>
) {
  yield call(SignalingSocket.send, { event: 'deleteLibraryFolder', data: action.payload });
}
